export const convertStringToNumber = (value: string, defaultValue: number = 0) => {
  const number = Number(value);
  if (Number.isNaN(number)) {
    return defaultValue;
  } else {
    return number;
  }
};
